import type { LiveState } from '../../lib/agent';

/**
 * The brand mark as agent state.
 *   idle     ○ ●      thinking ○ ◉      working ○ → ●
 *   waiting  ○ ● !    done     ○ ● ✓    offline ○ ○
 * Transitions are 320 ms and every end state is set by static CSS, so it is correct under
 * prefers-reduced-motion. Decorative: the label next to it carries the meaning.
 */
export function LiveMark({
  state,
  size = 24,
  className = '',
  title,
}: {
  state: LiveState;
  size?: 16 | 20 | 24 | 32;
  className?: string;
  /** Accessible name when the mark stands alone (header/rail). */
  title?: string;
}) {
  return (
    <svg
      viewBox="0 0 32 12"
      width={(size * 32) / 12}
      height={size}
      className={['live-mark shrink-0', className].join(' ')}
      data-state={state}
      role={title ? 'img' : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      focusable={false}
    >
      {title ? <title>{title}</title> : null}
      {/* first self: hollow ring */}
      <circle cx="6" cy="6" r="5" className="lm-a" />
      {/* second self */}
      <g className="lm-b-wrap">
        <circle cx="18" cy="6" r="5.5" className="lm-b-ring" />
        <circle cx="18" cy="6" r="5" className="lm-b" />
      </g>
      {/* badges */}
      <circle cx="28" cy="6" r="2.4" className="lm-wait" />
      <path d="m25 6 2 2 3.5-4" className="lm-done" />
    </svg>
  );
}
